import React, { useContext, useState,useEffect } from 'react';
import whitelogo from '../assets/img/logo.png';

import PersonIcon from '@mui/icons-material/Person';
import LogoutIcon from '@mui/icons-material/Logout';

import axios from 'axios';
import CircularProgress from '@mui/material/CircularProgress';
import {
    Navigate,
    Link,
    NavLink,
    useNavigate,
    useParams
  } from "react-router-dom";
  import { AppContext } from '../context';
  import { holdUser } from "../features/userdataSlice";

import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
// modal code start
import Typography from '@mui/material/Typography';
import { styled } from '@mui/material/styles';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import TextField from '@mui/material/TextField';
import IconButton from '@mui/material/IconButton';
import CloseIcon from "@mui/icons-material/Close";
// import { Link, useNavigate } from "react-router-dom";
// import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import DialogContent from '@mui/material/DialogContent';
import  secureLocalStorage  from  "react-secure-storage";

// modal code end
// modal code end
 // reset psd code modal end
      const BootstrapDialog = styled(Dialog)(({ theme }) => ({
        '& .MuiDialogContent-root': {
          padding: theme.spacing(2),
        },
        '& .MuiDialogActions-root': {
          padding: theme.spacing(1),
        },
      }));
      
      function BootstrapDialogTitle(props) {
        const { children, onClose, ...other } = props;
      
        return (
          <DialogTitle sx={{ m: 0, p: 2 }} {...other}>
            {children}
            {onClose ? (
              <IconButton
                aria-label="close"
                onClick={onClose}
                sx={{
                  position: 'absolute',
                  right: 8,
                  top: 8,
                  color: (theme) => theme.palette.grey[500],
                }}
              >
                <CloseIcon />
              </IconButton>
            ) : null}
          </DialogTitle>
        );
      }


function sentenceCase(str) {
 
    if ((str === null) || (str === ''))
        return false;
    else
        str = str.toString();
 
    return str.replace(/\w\S*/g,
        function (txt) {
            return txt.charAt(0).toUpperCase() +
                txt.substr(1).toLowerCase();
        });
}
function HeaderForm () {
   const { storage } = useContext(AppContext);
   
    const [showOrder, setShowOrder] = useState(false);
      const [userData, setuserData] = useState('');
    const dispatch = useDispatch();
     const Axios = axios.create({
        baseURL: storage[0].backEndUrl
        // baseURL: process.env.REACT_APP_ENV_URL
    });
    let navigate = useNavigate();
     const [openLog, setOpenLog] = React.useState(false);
  const handleOpenLog = () => setOpenLog(true);
  const handleCloselog = () => setOpenLog(false);
     const clear = (e) => {
        var olduserd=secureLocalStorage.getItem('oldstudid');;
           if(olduserd!=null && olduserd!=undefined){
            
            localStorage.setItem("studenentformdata", JSON.stringify([]));
             setOpenLog(false);
            window.location.reload();;
           }else{
             setOpenLog(false);
            window.location.reload();;
           }
    
      }
      const logout = (e) => {
        secureLocalStorage.removeItem("username");
         secureLocalStorage.removeItem("userdata");
         secureLocalStorage.removeItem("userlogin");
       
        dispatch(holdUser({}));
        navigate(`/`);
    
      }
   React.useEffect(() => {
       
    var userid= secureLocalStorage.getItem('userlogin');;
    var userdata =JSON.parse(secureLocalStorage.getItem('userdata'));

        // console.log(JSON.parse(secureLocalStorage.getItem('userdata')));
        if (userid == null || userdata==null || userdata==undefined) {


          navigate(`/`);

        }else{
           var res= JSON.parse(secureLocalStorage.getItem('userdata'));
           res.student_name=(sentenceCase(res.student_name));
         setuserData(res);
        }
      },[]);
  return (
    <>
   <div className='header'>
      <div className='container-fluid'>
        <div className='row'>
          <div className='col-md-12'>
            <div className='regis-header'>
              <div className='athe-img'>
              <Link to="/instruction"> <img src={whitelogo} alt='logo' className='logo' /></Link>

            <p>Version 1.5</p>

              </div>
              <div className='athe-right'>
                <ul >
               {/*  <li class="cleard"  onClick={() => {handleOpenLog()}}>Clear Data</li>*/}
                  <li><a><PersonIcon /> {userData!=null && 
                           <>
                           {userData.student_name}
                          
                    </>}
                         </a></li>
                  <li className='logt-sec'  onClick={() => {logout()}} role='button'><span className='content-sec'>Logout</span><LogoutIcon /></li>
                </ul>

              </div>
              </div>
          </div>
        </div>
        </div>
   </div>
    {/* modal section start */}
       
        <BootstrapDialog
          onClose={handleCloselog}
          aria-labelledby="customized-dialog-title"
          open={openLog} className="route-view copy-view logout-view  club-modal clear-form">
          <BootstrapDialogTitle className="close-routeview" id="customized-dialog-title" onClose={handleCloselog}>
            {/* <h2 style={{padding:'5px 0px 0px 0px',color:'#ffffff'}}>Logout</h2> */}
          </BootstrapDialogTitle>
          <DialogContent dividers>
            <Typography gutterBottom>
              <div className='copy-sec-modal logout-sec-modal add-club-sec' style={{ paddingTop: '0px' }}>
                {/* <h2 style={{color:'#57585A',paddingTop:'0px'}}>Logout</h2> */}
              
                <h2>You are about to lose all saved data, would you like to proceed?</h2>

                
            <div className='check-sec modal-check-sec'>
           

                <div className='row'>
                  <div className='col-md-12'>
                    <div className='login-submit login-submitss modal-submit login-clear'>
                        <button className='btn btn-login btn-submit' onClick={() => {clear()}}>Yes</button>
                         <button className='btn btn-cancel btn-login btn-down btn-no' onClick={() => {handleCloselog()}}>No</button>
                    </div>
              </div>
                </div>
            </div>
              </div>
            
             
            </Typography>
          </DialogContent>
        </BootstrapDialog>
        {/* modal section end */}
        </>
  )
}

export default HeaderForm;